import React from 'react'
import { Link } from 'react-router-dom';
import Nav from './Nav';
import Social from './Social';
import DialogBox from './DialogBox/DialogBox';

function Bio() {
  return (
    <header className='lg:sticky lg:top-0 lg:flex lg:max-h-screen lg:w-1/2 lg:flex-col lg:justify-between lg:py-24'>
        <div className="">
            <h1 className="text-4xl font-bold tracking-tight sm:text-5xl">Jerel Layog</h1>
            <h2 className="mt-3 text-lg font-medium tracking-tight sm:text-xl">Frontend Developer</h2>
            <p className='mt-4 max-w-xs leading-normal'>I build dynamic and interactive websites, ensuring a cohesive, accessible user experience.</p>
            <Nav />
        </div>
        <DialogBox />
        <Social />
        <Link
            to="/"
            className="mt-6 inline-block text-xs font-bold uppercase tracking-widest opacity-75 hover:opacity-100 hover:text-cherry-blossom transition-all"
        >
            ← View V2 Portfolio
        </Link>
    </header>
  )
}

export default Bio;